import { TextField } from "@material-ui/core"
import type { AutocompleteRenderInputParams } from "@material-ui/lab"
import { Autocomplete } from "@material-ui/lab"
import { useState } from "react"
import type { ChangeEvent, ReactElement } from "react"

export interface ISelectorProps {
  value: string
  onChange: (value: string) => void
  collection: string[]
}

export function SelectorComponent(props: ISelectorProps): ReactElement {
  const { value, onChange, collection } = props

  const [searchValue, setSearchValue] = useState<string>("")

  function onValueChange(_: ChangeEvent<{}>, val: string): void {
    onChange(val)
  }

  function onSearchChanged(event: ChangeEvent<HTMLInputElement>): void {
    setSearchValue(event.target.value)
  }

  function getOptions(): string[] {
    let options: string[] = [...collection]

    if (searchValue.length) {
      options = [searchValue, ...options]
    }

    return options
  }

  return (
    <Autocomplete
      options={getOptions()}
      disableClearable
      value={value}
      onChange={onValueChange}
      renderInput={(params: AutocompleteRenderInputParams) => (
        <TextField variant="outlined" {...params} value={searchValue} onChange={onSearchChanged} />
      )}
    />
  )
}
